import {CookieManager} from '../common/cookieManager';
import {OverlayManager} from '../common/overlayManager';

export class TooltipLayer {
    private readonly cookieManager: CookieManager;
    private readonly overlayManager: OverlayManager;

    private readonly merklisteCountElement: HTMLElement | null; // Nur im Shortcode nicht vorhanden!

    constructor() {
        this.cookieManager = new CookieManager();
        this.overlayManager = new OverlayManager();

        this.merklisteCountElement = document.getElementById('merkliste_count');

        const onScrollTooltip = () => {
            window.removeEventListener('scroll', onScrollTooltip); // Entfernt den Listener, damit es nur einmal ausgeloest wird
            this.showTooltip();
        };
        window.addEventListener('scroll', onScrollTooltip);
    }

    private showTooltip() {
        // LOG41-1498 Observer fuer den tooltip auf hover, bzw. die logik zum einmaligen anzeigen
        // Die Liste mit gleicher Logik gibt es einmal unter /internet aber auch unter /tarife
        // respektive sind die Selektoren hier gesetzt.
        // Der Selektor .cms-tarif-list-list > ul > .tarifbox:first-child .row1 ist fuer den Internet Bereich
        // Der Selektor .cms-tarif-list-list > ul > .tarifbox:first-child > div ist fuer die Tarifliste
        let firstTariffBox = document.querySelector(
            '.cms-tarif-list-list > ul > .tarifbox:first-child .row1, .cms-tarif-list-list > ul > .tarifbox:first-child > div',
        );
        const merklisteLayerDismissed = 'MERKLISTE_LAYER_DISMISSED';

        if (this.merklisteCountElement && parseInt(this.merklisteCountElement.innerHTML) > 0) {
            this.cookieManager.setCookie(merklisteLayerDismissed, 'true');

            return;
        }

        if (!firstTariffBox || this.cookieManager.getCookie(merklisteLayerDismissed)) {
            return;
        }

        let callbackForHeart = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const entryTarget = entry.target;
                    const closestContainer: HTMLElement = entryTarget.closest('.tarifbox') as HTMLElement;
                    const tooltipContainers: NodeListOf<HTMLElement> = closestContainer.querySelectorAll('.rememberTarif');
                    if (tooltipContainers.length === 0) {
                        return;
                    }

                    tooltipContainers.forEach((tooltipContainer) => {
                        // in der dslliste kann es zwei tooltips im container geben (mobil / desktop), daher
                        // wird hier geschaut, ob es das korrekte element ist
                        let correctContainer = false;
                        if (document.body.clientWidth < 767) {
                            if (!tooltipContainer.classList.contains('desktop')) {
                                correctContainer = true;
                            }
                        } else {
                            if (tooltipContainer.classList.contains('desktop')) {
                                correctContainer = true;
                            }
                        }
                        // in der normalen Tarifliste gibt es nur einen tooltip, daher immer true setzen
                        if (tooltipContainers.length === 1) {
                            correctContainer = true;
                        }

                        if (!correctContainer) {
                            return;
                        }

                        // suche den Inhalt aus einem im DOM bestehenden Tooltip raus:
                        const content = tooltipContainer.querySelector('[slot="content"]') as HTMLElement;

                        // hier wird der custom-tooltip / overlay zusammen gebaut:
                        const customToolTipContainer = document.createElement('div');
                        const tooltipElement = document.createElement('div');
                        tooltipElement.classList.add('custom-tooltip');

                        if (content && content.innerHTML) {
                            tooltipElement.innerHTML = content.innerHTML;
                        }

                        const xIcon = document.createElement('sl-icon');
                        xIcon.setAttribute('name', 'x-lg');

                        // hier wird der custom-tooltip  gesetzt:
                        tooltipElement.appendChild(xIcon);
                        customToolTipContainer.appendChild(tooltipElement);
                        tooltipContainer.appendChild(customToolTipContainer);

                        this.overlayManager.showRocketOverlayBackground();

                        this.overlayManager.preventScroll();

                        tooltipElement.classList.add('show');

                        // Element in den sichtbaren Bereich verschieben
                        setTimeout(() => {
                            customToolTipContainer.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                                inline: 'center',
                            });
                        }, 100);

                        // hier setzen wir die click events, um es wieder weg zu klicken (x-icon)
                        xIcon.addEventListener('click', (event) => {
                            this.hideTooltip(event, tooltipElement);
                        });

                        // hier setzen wir die click events, um es wieder weg zu klicken (rocket_overlay)
                        document.getElementById('rocket_overlay')?.addEventListener('click', (event) => {
                            this.hideTooltip(event, tooltipElement);
                        });

                        // hier setzen wir die click events, um es wieder weg zu klicken (overlay)
                        tooltipElement.addEventListener('click', (event) => {
                            this.hideTooltip(event, tooltipElement);
                        });

                        // tooltip soll nur einmal angezeigt werden
                        this.cookieManager.setCookie(merklisteLayerDismissed, 'true');

                        // Beobachtung beenden
                        observer.unobserve(entryTarget);
                    });
                }
            });
        };

        const optionsForHeart = {
            root: null, // Standard-Viewport
            rootMargin: '0px',
            threshold: 0.9, // Element muss zu 90% sichtbar sein
        };

        const observerForHeart = new IntersectionObserver(callbackForHeart, optionsForHeart);

        observerForHeart.observe(firstTariffBox);
    }

    private hideTooltip(event: Event, tooltipElement: HTMLDivElement) {
        event.preventDefault();
        event.stopPropagation();

        this.overlayManager.enableScroll();

        this.overlayManager.hideRocketOverlayBackground();
        tooltipElement.remove();
    }
}
